import { render, staticRenderFns } from "./WelcomePageTMF.vue?vue&type=template&id=118fe140&scoped=true&"
import script from "./WelcomePageTMF.vue?vue&type=script&lang=ts&"
export * from "./WelcomePageTMF.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomePageTMF.vue?vue&type=style&index=0&id=118fe140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118fe140",
  null
  
)

export default component.exports